export {
  FamilyIcon,
  MinistriesIcon,
  OutreachIcon,
  PrayerWorshipIcon,
  ToerustingIcon,
  ministryIcons,
} from "./ministry-icons";

export type { MinistryIconProps } from "./ministry-icons";
